<template>
  <div class="download-earn-root" :class="{ rtl: isRtl }">
    <main class="page">
      <section class="hero">
        <img class="hero-bg" :src="heroBg" alt="" />
        <img class="app-icon" :src="appIconSrc" alt="" />
      </section>

      <div class="headline-wrap">
        <h1 class="headline" v-html="titleHtml"></h1>
      </div>
      <button type="button" class="download-btn" @click="handleDown">
        <span class="download-btn-text">{{ btnText }}</span>
        <img class="download-btn-icon" :src="btnIcon" alt="" />
      </button>
    </main>
  </div>
</template>

<script>
import BaseConfig from '@/config/base.js'
import i18nMixin from './mixins/i18n.mixin'
import docMetaMixin from './mixins/doc-meta.mixin'

const CAMPAIGN = 'invite_male_users_to_earn'

function mkItem(logo, showName, link, needParams) {
  return link ? { logo: logo, showName: showName, link: link, needParams: needParams } : null
}

const downloadStrategies = {
  vava: (links) => ({
    google: mkItem('vava', 'Vava', links.vava.android, true),
    apple: mkItem('vava', 'Vava', links.vava.ios, false),
  }),
  echo: (links) => ({
    google: mkItem('echo', 'Echo', links.echo.android, true),
    apple: mkItem('echo', 'Echo', links.echo.ios, false),
  }),
  joychat: (links) => ({
    google: mkItem('joychat', 'Joychat', links.joychat.android, true),
    apple: mkItem('joychat', 'Joychat', links.joychat.ios, false),
  }),
  joyu: (links) => ({
    google: mkItem('joyu', 'Joyu', links.joyu.android, true),
    apple: null,
  }),
  kiko: (links) => ({
    google: mkItem('kiko', 'Kiko', links.kiko.android, true),
    apple: null,
  }),
  vibeo: (links) => ({
    google: mkItem('vibeo', 'Vibeo', links.vibeo.android, true),
    apple: null,
  }),
  whonow: (links) => ({
    google: mkItem('whonow', 'Whonow', links.whonow.android, true),
    apple: null,
  }),
}

export default {
  name: 'DownloadEarn',
  mixins: [i18nMixin, docMetaMixin],
  data() {
    return {
      pagePackage: '',
      downloadItem: null,
      code: '',
      utmSource: 'male_invite',
    }
  },
  computed: {
    appIconSrc() {
      return '/download_logo/' + this.pagePackage + '-logo.webp'
    },
    heroBg() {
      // prettier-ignore
      try {
        return require('./images/bg.png')
      }
      catch (e) {
        return ''
      }
    },
    btnIcon() {
      // prettier-ignore
      try {
        return require('./images/download.webp')
      }
      catch (e) {
        return ''
      }
    },
  },
  created() {
    const query = this.$route.query || {}

    const appName = query.appName || 'com.client.goparty'
    const packageName = BaseConfig.packageNameMap[appName] || ''
    const fromIos = this.env.isIOS

    this.code = query.code || ''

    // 苹果系统：包logo用echo 和 下载链接用echo下ios
    if (fromIos) {
      const echoDownloadInfo = downloadStrategies.echo(BaseConfig.downloadLinks)

      this.downloadItem = echoDownloadInfo.apple || echoDownloadInfo.google
      this.pagePackage = 'echo'
    }
    // android系统
    else {
      const strategy = downloadStrategies[packageName]
      const curPkgDownloadInfo = strategy ? strategy(BaseConfig.downloadLinks) : null

      this.downloadItem = curPkgDownloadInfo ? curPkgDownloadInfo.google || curPkgDownloadInfo.apple : null
      this.pagePackage = packageName
    }
  },
  mounted() {
    this.applyLangDir()
    this.setDocMeta()
    this.traceAction({ action: 'click', aposition: 'entrance', avalue: 'download_page', campaign: CAMPAIGN })
  },
  beforeDestroy() {
    this.restoreLangDir()
  },
  methods: {
    handleDown() {
      this.traceAction({ action: 'click', aposition: 'button', avalue: 'download', campaign: CAMPAIGN })
      if (!this.downloadItem) {
        return
      }

      let openUrl = ''
      if (this.downloadItem.needParams && this.downloadItem.link) {
        openUrl = this.downloadItem.link + '&referrer=' + encodeURIComponent('utm_source=' + this.utmSource + '&utm_medium=' + this.code)
      }

      this.handleCopy(this.code, this.copiedText)

      if (openUrl) {
        window.open(openUrl, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.download-earn-root {
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  width: 100%;
  min-height: 100vh;
  background: #f9f4f0;
  font-family: 'Inter-Regular';
  -webkit-font-smoothing: antialiased;

  .page {
    position: relative;
    width: 100%;
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    background: #f9f4f0;
    overflow: hidden;
  }

  .hero {
    position: relative;
    width: 100%;
    height: 507.75px;

    .hero-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
    }

    .app-icon {
      position: absolute;
      bottom: 25.01px;
      left: 50%;
      transform: translateX(-50%);
      width: 79.99px;
      height: 79.99px;
      border-radius: 16.01px;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.18);
      object-fit: cover;
      z-index: 2;
    }
  }

  .headline-wrap {
    position: relative;
    z-index: 1;
    padding: 34.01px 24px 40.01px;
    background: url('./images/bg-r.png') repeat;
    text-align: center;
  }

  .headline {
    font-family: 'LeagueGothic-Regular', Impact, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 72px;
    line-height: 73.99px;
    letter-spacing: -0.56px;
    color: #252525;
    text-align: center;
  }

  .download-btn {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 327px;
    height: 64.01px;
    margin: 0 auto 40.01px;
    border: none;
    border-radius: 18px;
    background: #fdc818;
    cursor: pointer;

    .download-btn-text {
      font-family: 'Inter-Regular', sans-serif;
      font-weight: 700;
      font-size: 22.99px;
      line-height: 28.01px;
      color: #743d00;
      white-space: nowrap;
    }

    .download-btn-icon {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
}
</style>
